<ng-container *ngIf="page">
  <ng-container *ngIf="brConfig?.fundId; else previewBlock">
    <ng-container *ngIf="documents && documents.length > 0">
      <ng-container *ngIf="documents.length === 1">
        <div *ngFor="let doc of documents">
          <eds-title
            [title]="doc.title"
            [level]="3"
            theme="primary"
            size="h5"
            [isLight]="true"
            edsSpacing="lg"
          ></eds-title>
          <!-- No risk factor -->
          <div edsRow *ngIf="!doc.showRiskFactor">
            <div edsCol [columnNumbers]="{ s: 4, m: 8, l: 10 }">
              <div>
                <ng-container
                  *ngTemplateOutlet="
                    contentBlocks;
                    context: {
                      blocks: doc.contentblocks
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>

          <!-- risk factor -->
          <div edsRow *ngIf="doc.showRiskFactor">
            <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 6 }">
              <ng-container *ngFor="let contentBlock of doc.contentblocks">
                <div>
                  <ng-container
                    *ngTemplateOutlet="
                      itemBlock;
                      context: {
                        item: contentBlock,
                        isTwoCol: true
                      }
                    "
                  ></ng-container>
                </div>
              </ng-container>
            </div>
            <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 4 }">
              <eds-panel [hasPadding]="true" theme="basic">
                <!-- Canada Variant of Risk Factor -->
                <ng-container
                  *ngIf="doc?.regulatorLinkURL !== null; else nonLinkRiskFactor"
                >
                  <a
                    [href]="doc.regulatorLinkURL"
                    class="external-link"
                    target="_blank"
                  >
                    <eds-risk-factor
                      *ngIf="isCanada"
                      [strRank]="doc.strRank"
                      [title]="
                        'products.risk-factor-ca-title'
                          | translate: brConfig.fundId
                      "
                      [strRiskFactorScale]="strRiskFactorScale"
                      [variation]="doc.variation"
                      [altText]="
                        'products.risk-factor-alt-arrow'
                          | translate: brConfig.fundId
                      "
                    ></eds-risk-factor>
                    <!-- Numeric Rank Factor  -->
                    <eds-risk-factor
                      *ngIf="!isCanada"
                      [rank]="doc.rank"
                      [title]="
                        'products.risk-factor-title'
                          | translate: brConfig.fundId
                      "
                      [highRiskLabel]="
                        'products.high-risk-label' | translate: brConfig.fundId
                      "
                      [highRiskSubLabel]="
                        'products.high-risk-sub-label'
                          | translate: brConfig.fundId
                      "
                      [lowRiskLabel]="
                        'products.low-risk-label' | translate: brConfig.fundId
                      "
                      [lowRiskSubLabel]="
                        'products.low-risk-sub-label'
                          | translate: brConfig.fundId
                      "
                      [variation]="doc.variation"
                      [altText]="
                        'products.risk-factor-alt-arrow'
                          | translate: brConfig.fundId
                      "
                    ></eds-risk-factor>
                  </a>
                </ng-container>
                <ng-template #nonLinkRiskFactor>
                  <eds-risk-factor
                    *ngIf="isCanada"
                    [strRank]="doc.strRank"
                    [title]="
                      'products.risk-factor-ca-title'
                        | translate: brConfig.fundId
                    "
                    [strRiskFactorScale]="strRiskFactorScale"
                    [variation]="doc.variation"
                    [altText]="
                      'products.risk-factor-alt-arrow'
                        | translate: brConfig.fundId
                    "
                  ></eds-risk-factor>
                  <!-- Numeric Rank Factor  -->
                  <eds-risk-factor
                    *ngIf="!isCanada"
                    [rank]="doc.rank"
                    [title]="
                      'products.risk-factor-title' | translate: brConfig.fundId
                    "
                    [highRiskLabel]="
                      'products.high-risk-label' | translate: brConfig.fundId
                    "
                    [highRiskSubLabel]="
                      'products.high-risk-sub-label'
                        | translate: brConfig.fundId
                    "
                    [lowRiskLabel]="
                      'products.low-risk-label' | translate: brConfig.fundId
                    "
                    [lowRiskSubLabel]="
                      'products.low-risk-sub-label' | translate: brConfig.fundId
                    "
                    [variation]="doc.variation"
                    [altText]="
                      'products.risk-factor-alt-arrow'
                        | translate: brConfig.fundId
                    "
                  ></eds-risk-factor>
                </ng-template>
              </eds-panel>
            </div>
          </div>
        </div>
      </ng-container>

      <eds-tabs
        [followFocus]="true"
        [isNavigation]="false"
        [cacheActive]="true"
        [fullWidth]="true"
        *ngIf="documents.length > 1"
        dropdownTheme="handheld"
      >
        <ng-container *ngFor="let doc of documents; let i = index">
          <eds-tab
            [heading]="doc.title"
            (selected)="onSelected(doc.title)"
            [tabId]="doc?.tabId"
          >
            <!-- No risk factor -->
            <div edsRow *ngIf="!doc.showRiskFactor">
              <div edsCol [columnNumbers]="{ s: 4, m: 8, l: 10 }">
                <div>
                  <ng-container
                    *ngTemplateOutlet="
                      contentBlocks;
                      context: {
                        blocks: doc.contentblocks
                      }
                    "
                  ></ng-container>
                </div>
              </div>
            </div>

            <!-- Show Risk Factor -->
            <div edsRow *ngIf="doc.showRiskFactor">
              <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 6 }">
                <ng-container *ngFor="let contentBlock of doc.contentblocks">
                  <div>
                    <ng-container
                      *ngTemplateOutlet="
                        itemBlock;
                        context: {
                          item: contentBlock,
                          isTwoCol: true
                        }
                      "
                    ></ng-container>
                  </div>
                </ng-container>
              </div>
              <div edsCol [columnNumbers]="{ s: 4, m: 4, l: 4 }">
                <eds-panel [hasPadding]="true" theme="basic">
                  <ng-container
                    *ngIf="
                      doc?.regulatorLinkURL !== null;
                      else nonLinkRiskFactor
                    "
                  >
                    <a
                      [href]="doc.regulatorLinkURL"
                      class="external-link"
                      target="_blank"
                    >
                      <eds-risk-factor
                        *ngIf="isCanada"
                        [strRank]="doc.strRank"
                        [title]="
                          'products.risk-factor-ca-title'
                            | translate: brConfig.fundId
                        "
                        [strRiskFactorScale]="strRiskFactorScale"
                        [variation]="doc.variation"
                        [altText]="
                          'products.risk-factor-alt-arrow'
                            | translate: brConfig.fundId
                        "
                      ></eds-risk-factor>
                      <!-- Numeric Rank Factor  -->
                      <eds-risk-factor
                        *ngIf="!isCanada"
                        [rank]="doc.rank"
                        [title]="
                          'products.risk-factor-title'
                            | translate: brConfig.fundId
                        "
                        [highRiskLabel]="
                          'products.high-risk-label'
                            | translate: brConfig.fundId
                        "
                        [highRiskSubLabel]="
                          'products.high-risk-sub-label'
                            | translate: brConfig.fundId
                        "
                        [lowRiskLabel]="
                          'products.low-risk-label' | translate: brConfig.fundId
                        "
                        [lowRiskSubLabel]="
                          'products.low-risk-sub-label'
                            | translate: brConfig.fundId
                        "
                        [variation]="doc.variation"
                        [altText]="
                          'products.risk-factor-alt-arrow'
                            | translate: brConfig.fundId
                        "
                      ></eds-risk-factor>
                    </a>
                  </ng-container>
                  <ng-template #nonLinkRiskFactor>
                    <eds-risk-factor
                      *ngIf="isCanada"
                      [strRank]="doc.strRank"
                      [title]="
                        'products.risk-factor-ca-title'
                          | translate: brConfig.fundId
                      "
                      [strRiskFactorScale]="strRiskFactorScale"
                      [variation]="doc.variation"
                      [altText]="
                        'products.risk-factor-alt-arrow'
                          | translate: brConfig.fundId
                      "
                    ></eds-risk-factor>
                    <!-- Numeric Rank Factor  -->
                    <eds-risk-factor
                      *ngIf="!isCanada"
                      [rank]="doc.rank"
                      [title]="
                        'products.risk-factor-title'
                          | translate: brConfig.fundId
                      "
                      [highRiskLabel]="
                        'products.high-risk-label' | translate: brConfig.fundId
                      "
                      [highRiskSubLabel]="
                        'products.high-risk-sub-label'
                          | translate: brConfig.fundId
                      "
                      [lowRiskLabel]="
                        'products.low-risk-label' | translate: brConfig.fundId
                      "
                      [lowRiskSubLabel]="
                        'products.low-risk-sub-label'
                          | translate: brConfig.fundId
                      "
                      [variation]="doc.variation"
                      [altText]="
                        'products.risk-factor-alt-arrow'
                          | translate: brConfig.fundId
                      "
                    ></eds-risk-factor>
                  </ng-template>
                </eds-panel>
              </div>
            </div>
          </eds-tab>
        </ng-container>
      </eds-tabs>

      <ng-template #contentBlocks let-blocks="blocks">
        <ng-container *ngFor="let contentBlock of blocks">
          <!-- 2 Column Block -->
          <ng-container *ngIf="contentBlock.itemsTwo">
            <div class="container">
              <div edsRow>
                <div
                  edsCol
                  [edsSubGrid]="
                    contentBlock.layout ? contentBlock.layout : 'layout-1'
                  "
                  edsSubGridGap="lg"
                  [edsSubGridTablet]="
                    (isHandheld$ | async)
                      ? 'layout-1'
                      : contentBlock.layout || 'layout-1'
                  "
                  edsSubGridTabletGap="lg"
                >
                  <!-- Column 1-->
                  <div
                    edsGridItemOrder
                    [itemOrderDesktop]="
                      contentBlock.desktopGridOrder ? 2 : 'auto'
                    "
                    [itemOrderTablet]="
                      contentBlock.tabletGridOrder ? 2 : 'auto'
                    "
                    [itemOrderMobile]="
                      contentBlock.mobileGridOrder ? 2 : 'auto'
                    "
                    [ngStyle]="
                      (isMobile$ | async)
                        ? {}
                        : {
                            'align-self':
                              contentBlock.verticalAlignment || 'start'
                          }
                    "
                  >
                    <ng-container *ngFor="let subBlock of contentBlock.items">
                      <div>
                        <ng-container
                          *ngTemplateOutlet="
                            itemBlock;
                            context: {
                              item: subBlock,
                              isTwoCol: true
                            }
                          "
                        ></ng-container>
                      </div>
                    </ng-container>
                  </div>

                  <div
                    edsGridItemOrder
                    [itemOrderDesktop]="
                      contentBlock.desktopGridOrder ? 1 : 'auto'
                    "
                    [itemOrderTablet]="
                      contentBlock.tabletGridOrder ? 1 : 'auto'
                    "
                    [itemOrderMobile]="
                      contentBlock.mobileGridOrder ? 1 : 'auto'
                    "
                    [ngStyle]="
                      (isMobile$ | async)
                        ? {}
                        : {
                            'align-self':
                              contentBlock.verticalAlignment || 'start'
                          }
                    "
                  >
                    <ng-container
                      *ngFor="let subBlock of contentBlock.itemsTwo"
                    >
                      <div>
                        <ng-container
                          *ngTemplateOutlet="
                            itemBlock;
                            context: {
                              item: subBlock,
                              isTwoCol: true
                            }
                          "
                        ></ng-container>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <!-- 1 Col Block multiple items-->
          <ng-container *ngIf="!contentBlock.itemsTwo && contentBlock.items">
            <div>
              <ng-container *ngFor="let subBlock of contentBlock.items">
                <div>
                  <ng-container
                    *ngTemplateOutlet="
                      itemBlock;
                      context: {
                        item: subBlock,
                        isTwoCol: false
                      }
                    "
                  ></ng-container>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <!-- 1 Col Block-->
          <ng-container *ngIf="!contentBlock.itemsTwo && !contentBlock.items">
            <div>
              <ng-container
                *ngTemplateOutlet="
                  itemBlock;
                  context: {
                    item: contentBlock,
                    isTwoCol: false
                  }
                "
              ></ng-container>
            </div>
          </ng-container>
        </ng-container>
      </ng-template>

      <ng-template #itemBlock let-item="item" let-isTwoCol="isTwoCol">
        <div
          [edsSpacing]="
            !item.spacingBottom || item.spacingBottom === 'auto'
              ? 'lg'
              : item.spacingBottom
          "
        >
          <ng-container [ngSwitch]="item.contentType">
            <!-- EDS Title -->
            <ng-container *ngSwitchCase="'ftcore:TitleBlock'">
              <div edsRow *ngIf="item.preTitle">
                <div edsCol>
                  <p class="pre-title">{{ item.preTitle }}</p>
                </div>
              </div>
              <!--row -->
              <div edsRow>
                <eds-title
                  edsSpacing="md"
                  edsCol
                  [isLight]="true"
                  [title]="item.title"
                  size="h5"
                  [level]="5"
                  [theme]="'basic'"
                ></eds-title>
              </div>
            </ng-container>
            <!-- EDS Title -->

            <!-- EDS Intro -->
            <ng-container *ngSwitchCase="'ftcore:IntroBlock'">
              <!-- Intro Content Area -->
              <div edsRow>
                <div edsCol>
                  <p class="large">
                    {{ item.content }}
                  </p>
                </div>
              </div>
            </ng-container>
            <!-- EDS Intro -->

            <!-- EDS Paragraph -->
            <ng-container *ngSwitchCase="'ftcore:ParagraphBlock'">
              <div class="ck-editor">
                <div edsRow>
                  <div edsCol [innerHTML]="item.content"></div>
                </div>
              </div>
            </ng-container>
            <!-- EDS Paragraph -->

            <ng-container *ngSwitchCase="'ftcore:Blockquote'">
              <ft-blockquote-block
                [content]="item"
                [isTwoCol]="isTwoCol"
              ></ft-blockquote-block>
            </ng-container>

            <ng-container *ngSwitchCase="'ftcore:Avatar'">
              <ft-avatar-block
                [content]="item"
                [isTwoCol]="isTwoCol"
                [page]="page"
              ></ft-avatar-block>
            </ng-container>

            <ng-container *ngSwitchCase="'ftcore:EmbeddedVideo'">
              <div edsRow>
                <div edsCol>
                  <eds-video
                    edsSpacing="xl"
                    [embedScript]="item.videoEmbedCode"
                    [loadVideo]="loadVideoflag"
                  >
                  </eds-video>
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'ftcore:CardGroupCompound'">
              <ft-media-card-group
                *ngIf="!isTwoCol"
                [contentBlock]="item"
                [page]="page"
              ></ft-media-card-group>
              <ft-media-card-block
                *ngIf="isTwoCol"
                [contentBlock]="item"
                [page]="page"
              ></ft-media-card-block>
            </ng-container>
            <ng-container *ngSwitchCase="'ftcore:ImageCompound'">
              <ft-image-block [content]="item"></ft-image-block>
            </ng-container>
            <ng-container *ngSwitchCase="'ftcore:ChartBlock'">
              <div [innerHTML]="item.chart | safeHtml"></div>
            </ng-container>
            <ng-container *ngSwitchDefault>
              <!-- Image Block-->
              <ng-container *ngIf="item.widenAsset; else button">
                <ft-image-block [content]="item"></ft-image-block>
              </ng-container>
              <!-- Button block-->
              <ng-container #button>
                <ft-buttons-block
                  [content]="item"
                  [page]="page"
                ></ft-buttons-block>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>

<ng-template #previewBlock>
  <h5 *ngIf="page && isEditMode">
    Fund Content Component - {{ brConfig.location }}
  </h5>
</ng-template>
